module.exports = __webpack_public_path__ + "static/metal-forging-8a49b94655f7d7fbb5698f77d1fa71ca.png";